var map = {
	"./": [
		"088c"
	],
	"./chat/attachment": [
		"fc75",
		"chunk-2d237951"
	],
	"./chat/attachment.vue": [
		"fc75",
		"chunk-2d237951"
	],
	"./chat/phone": [
		"f979",
		"chunk-2d22dbab"
	],
	"./chat/phone.vue": [
		"f979",
		"chunk-2d22dbab"
	],
	"./chat/send": [
		"5c59",
		"chunk-2d0d32e8"
	],
	"./chat/send.vue": [
		"5c59",
		"chunk-2d0d32e8"
	],
	"./index": [
		"088c"
	],
	"./index.js": [
		"088c"
	],
	"./nav/chat": [
		"0efd",
		"chunk-2d0afaa9"
	],
	"./nav/chat.vue": [
		"0efd",
		"chunk-2d0afaa9"
	],
	"./nav/phone": [
		"8e6f",
		"chunk-2d0e97d3"
	],
	"./nav/phone.vue": [
		"8e6f",
		"chunk-2d0e97d3"
	],
	"./nav/settings": [
		"7195",
		"chunk-2d0d606c"
	],
	"./nav/settings.vue": [
		"7195",
		"chunk-2d0d606c"
	],
	"./nav/user": [
		"a30b",
		"chunk-2d207e9a"
	],
	"./nav/user.vue": [
		"a30b",
		"chunk-2d207e9a"
	],
	"./nav/users": [
		"71b9",
		"chunk-2d0d6567"
	],
	"./nav/users.vue": [
		"71b9",
		"chunk-2d0d6567"
	],
	"./template": [
		"d71e"
	],
	"./template.vue": [
		"d71e"
	],
	"./ui/add": [
		"4755",
		"chunk-2d0c1959"
	],
	"./ui/add.vue": [
		"4755",
		"chunk-2d0c1959"
	],
	"./ui/cart": [
		"5481",
		"chunk-2d0c82ce"
	],
	"./ui/cart.vue": [
		"5481",
		"chunk-2d0c82ce"
	],
	"./ui/check": [
		"778d",
		"chunk-2d0d7702"
	],
	"./ui/check.vue": [
		"778d",
		"chunk-2d0d7702"
	],
	"./ui/chevron": [
		"d34d",
		"chunk-2d21dc35"
	],
	"./ui/chevron.vue": [
		"d34d",
		"chunk-2d21dc35"
	],
	"./ui/close": [
		"b076",
		"chunk-2d20e863"
	],
	"./ui/close-circle": [
		"4ef3",
		"chunk-2d0ccbf4"
	],
	"./ui/close-circle.vue": [
		"4ef3",
		"chunk-2d0ccbf4"
	],
	"./ui/close.vue": [
		"b076",
		"chunk-2d20e863"
	],
	"./ui/download": [
		"f564",
		"chunk-2d22cc83"
	],
	"./ui/download.vue": [
		"f564",
		"chunk-2d22cc83"
	],
	"./ui/like": [
		"3098",
		"chunk-2d0b8b32"
	],
	"./ui/like.vue": [
		"3098",
		"chunk-2d0b8b32"
	],
	"./ui/order": [
		"e1cb",
		"chunk-2d224ec1"
	],
	"./ui/order.vue": [
		"e1cb",
		"chunk-2d224ec1"
	],
	"./ui/profile": [
		"0c65",
		"chunk-2d0aed28"
	],
	"./ui/profile.vue": [
		"0c65",
		"chunk-2d0aed28"
	],
	"./ui/search": [
		"100a",
		"chunk-2d0aa186"
	],
	"./ui/search.vue": [
		"100a",
		"chunk-2d0aa186"
	],
	"./ui/star": [
		"1b00",
		"chunk-2d0b5d07"
	],
	"./ui/star.vue": [
		"1b00",
		"chunk-2d0b5d07"
	],
	"./ui/trash": [
		"1ac8",
		"chunk-2d0b5f7b"
	],
	"./ui/trash.vue": [
		"1ac8",
		"chunk-2d0b5f7b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2677";
module.exports = webpackAsyncContext;